import { css } from '@emotion/css';

import { GrafanaTheme2 } from '@grafana/data';
import { Icon, Stack, useStyles2, DatePickerWithInput, DatePickerWithInputProps } from '@grafana/ui';

interface DatePickerInputProps extends DatePickerWithInputProps {
  onClear?: () => void;
}

export function DatePickerInput({ onClear, ...props }: DatePickerInputProps) {
  const styles = useStyles2(getStyles);

  return (
    <DatePickerWithInput
      {...props}
      closeOnSelect
      suffix={
        <Stack gap={1} alignItems="center">
          {props.value && onClear && <Icon name="times" size="lg" className={styles.iconButton} onClick={onClear} />}
          <Icon name="calendar-alt" />
        </Stack>
      }
    />
  );
}

const getStyles = (theme: GrafanaTheme2) => {
  return {
    iconButton: css({
      '&:hover': {
        color: theme.colors.text.maxContrast,
      },
      cursor: 'pointer',
    }),
  };
};
